import React, { FC } from 'react';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import PartGeneralContent from './components/PartGeneralContent';
import ImagesContainer, { ImagesContainerMode } from '@v2/pages/common/components/ImagesContainer/ImagesContainer';
import { NOT_PANEL_VIEW_MODE_WIDTH, MACHINES_PAGES_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import { View } from 'react-native';

interface PartGeneralProps extends NavigationProps {}

const PartGeneral: FC<PartGeneralProps> = ({ lg }) => {
  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
      withDefaultComponent
    >
      <View style={MACHINES_PAGES_CONTAINER_STYLES}>
        <PartGeneralContent withImages />
      </View>
    </MachinesProvider>
  );
};

export { PartGeneral };
